export function renderMarkdown(md: string): string {
    if (!md) return "";

    const escaped = md
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;");

    const lines = escaped.split("\n");
    let html = "";
    let inList = false;

    for (let i = 0; i < lines.length; i++) {
        let line = lines[i];

        if (line.startsWith("### ")) {
            if (inList) { html += "</ul>"; inList = false; }
            html += `<h3>${inline(line.slice(4))}</h3>`;
        } else if (line.startsWith("## ")) {
            if (inList) { html += "</ul>"; inList = false; }
            html += `<h2>${inline(line.slice(3))}</h2>`;
        } else if (line.startsWith("# ")) {
            if (inList) { html += "</ul>"; inList = false; }
            html += `<h1>${inline(line.slice(2))}</h1>`;
        }
        else if (line.match(/^\s*[-*]\s+/)) {
            if (!inList) { html += "<ul>"; inList = true; }
            html += `<li>${inline(line.replace(/^\s*[-*]\s+/, ""))}</li>`;
        }
        else if (line.trim() === "") {
            if (inList) { html += "</ul>"; inList = false; }
            html += "<br/>";
        }
        else {
            if (inList) { html += "</ul>"; inList = false; }
            html += `<p class="mb-0">${inline(line)}</p>`;
        }
    }

    if (inList) html += "</ul>";
    return html;
}

function inline(text: string): string {
    text = text.replace(/\*\*(.+?)\*\*/g, "<strong>$1</strong>");
    text = text.replace(/\*(.+?)\*/g, "<em>$1</em>");
    return text;
}
